import styles from './styles.module.scss';

import { PopUpBox } from '../PopUpBox';
import { AlertColor } from '../../types';
import { Button } from '../Button';
import { uniqueId } from 'lodash';

export type AlertDialogOption = {
    text: string;
    action: Function;
    type: AlertColor;
};

export interface AlertDialogType {
    title: string;
    message: JSX.Element | string;
    options: AlertDialogOption[];
}

interface AlertDialogProps extends AlertDialogType {
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    open: React.ComponentState;
}

export const AlertDialog = ({ setOpen, open, title, message, options }: AlertDialogProps) => {
    const handleAction = (action: Function) => {
        action();
        setOpen(false);
    };

    const renderOption = (option: AlertDialogOption) => {
        return (
            <Button
                key={uniqueId('alertDialog')}
                type={option.type}
                onClick={() => handleAction(option.action)}
            >
                {option.text}
            </Button>
        );
    };

    return (
        <>
            <PopUpBox wrapperClass={styles.popUpBox} open={open} setOpen={setOpen}>
                <div className={styles.header}>
                    <div
                        className='fa fa-times'
                        aria-hidden='true'
                        onClick={() => setOpen(false)}
                    ></div>
                </div>

                <div className={styles.title}>{title}</div>

                <div className={styles.message}>{message}</div>

                <div
                    className={`${styles.btnBox} ${
                        options.length === 1
                            ? styles.alignCenter
                            : options.length === 2
                            ? styles.spaceBetween
                            : styles.alignRight
                    }`}
                >
                    {options.map(renderOption)}
                </div>
            </PopUpBox>
        </>
    );
};
